import React from 'react';
import Chip from '@material-ui/core/Chip';
import ClockFast from 'mdi-material-ui/ClockFast';

import { PageHeader } from 'app/components/PageHeader';
import { LabelEnum } from 'app/shared/enums';
import { useStyles } from './TerminationGeneratorViewHeader.styles';

export default function TerminationGeneratorViewHeader() {
  const classes = useStyles();

  const secondTitle = (
    <>
      <div className={classes.pageHeaderText}>
        {LabelEnum.TerminationGeneratorText1}
        <strong>{LabelEnum.TerminationGeneratorText2}</strong>
        {LabelEnum.TerminationGeneratorText3}
      </div>
      <Chip
        icon={<ClockFast className={classes.pageHeaderChipIcon} />}
        label={LabelEnum.TerminationGeneratorChipLabel}
        className={classes.pageHeaderChip}
        classes={{ label: classes.pageHeaderChipLabel }}
      />
    </>
  );

  return (
    <PageHeader
      title={LabelEnum.TerminationGeneratorHeading}
      secondTitle={secondTitle}
      className={classes.pageHeader}
    />
  );
}
